import { defineMessages } from '../define';

/**
 * Session lifecycle vocabulary. Shared rather than owned by the sessions screen
 * because the same eleven states appear in the sidebar, the dashboard, the
 * command palette and every session picker.
 */
export const status = defineMessages({
  en: {
    'status.CREATED': 'Created',
    'status.CREATED.hint': 'Not started yet',
    'status.LAUNCHING': 'Launching',
    'status.LAUNCHING.hint': 'Starting the browser',
    'status.WAITING_QR': 'Waiting for scan',
    'status.WAITING_QR.hint': 'Scan the QR code with LINE',
    'status.QR_EXPIRED': 'QR expired',
    'status.QR_EXPIRED.hint': 'A new code is being generated',
    'status.AUTHENTICATING': 'Authenticating',
    'status.AUTHENTICATING.hint': 'Confirm the login on your phone',
    'status.CONNECTED': 'Connected',
    'status.CONNECTED.hint': 'Receiving messages',
    'status.DISCONNECTED': 'Disconnected',
    'status.DISCONNECTED.hint': 'Lost contact with the browser',
    'status.RECONNECTING': 'Reconnecting',
    'status.RECONNECTING.hint': 'Trying to restore the session',
    'status.LOGGED_OUT': 'Logged out',
    'status.LOGGED_OUT.hint': 'Signed out of LINE',
    'status.STOPPED': 'Stopped',
    'status.STOPPED.hint': 'Stopped by an operator',
    'status.ERROR': 'Error',
    'status.ERROR.hint': 'Needs attention',

    'chatType.PRIVATE': 'Private',
    'chatType.GROUP': 'Group',
    'chatType.ROOM': 'Room',
    'chatType.OFFICIAL': 'Official',
    'chatType.UNKNOWN': 'Unknown',

    'role.OWNER': 'Owner',
    'role.ADMIN': 'Administrator',
    'role.OPERATOR': 'Operator',
    'role.VIEWER': 'Viewer',
  },
  th: {
    'status.CREATED': 'สร้างแล้ว',
    'status.CREATED.hint': 'ยังไม่ได้เริ่มทำงาน',
    'status.LAUNCHING': 'กำลังเริ่ม',
    'status.LAUNCHING.hint': 'กำลังเปิดเบราว์เซอร์',
    'status.WAITING_QR': 'รอสแกน',
    'status.WAITING_QR.hint': 'สแกน QR code ด้วยแอป LINE',
    'status.QR_EXPIRED': 'QR หมดอายุ',
    'status.QR_EXPIRED.hint': 'กำลังสร้างรหัสใหม่',
    'status.AUTHENTICATING': 'กำลังยืนยันตัวตน',
    'status.AUTHENTICATING.hint': 'ยืนยันการเข้าสู่ระบบบนโทรศัพท์ของคุณ',
    'status.CONNECTED': 'เชื่อมต่อแล้ว',
    'status.CONNECTED.hint': 'กำลังรับข้อความ',
    'status.DISCONNECTED': 'ขาดการเชื่อมต่อ',
    'status.DISCONNECTED.hint': 'ติดต่อกับเบราว์เซอร์ไม่ได้',
    'status.RECONNECTING': 'กำลังเชื่อมต่อใหม่',
    'status.RECONNECTING.hint': 'กำลังพยายามกู้คืนเซสชัน',
    'status.LOGGED_OUT': 'ออกจากระบบแล้ว',
    'status.LOGGED_OUT.hint': 'ออกจากระบบ LINE แล้ว',
    'status.STOPPED': 'หยุดทำงาน',
    'status.STOPPED.hint': 'ถูกหยุดโดยผู้ดูแล',
    'status.ERROR': 'ข้อผิดพลาด',
    'status.ERROR.hint': 'ต้องการการตรวจสอบ',

    'chatType.PRIVATE': 'ส่วนตัว',
    'chatType.GROUP': 'กลุ่ม',
    'chatType.ROOM': 'ห้องแชท',
    'chatType.OFFICIAL': 'บัญชีทางการ',
    'chatType.UNKNOWN': 'ไม่ทราบ',

    'role.OWNER': 'เจ้าของ',
    'role.ADMIN': 'ผู้ดูแลระบบ',
    'role.OPERATOR': 'ผู้ปฏิบัติงาน',
    'role.VIEWER': 'ผู้อ่าน',
  },
});
